export enum MasterCalendarBlock {
  Root = 'MasterCalendar',
}
